export default {
    getRecordFilter: (state) => state.filter,
    getRecordList: (state) => state.list,
    getRecordResult: (state) => state.result,
    getRecordValidation: (state) => state.validation,
  };